import { configureStore } from "@reduxjs/toolkit";
import AppStateSlice from "./slices/AppState";
import ProductState from "./slices/ProductState";
import AuthSlice from "./slices/Auth";
import Order from "./slices/OrderSocketState";
import StaffStateSlice from "./slices/StaffState";
import FeedbackStateSlice from "./slices/FeedbackState";
import ErrorStateSlice from "./slices/ErrorSlice";
import PackageState from "./slices/PackageState";
import ComboSlice from "./slices/ComboState";
import CampaignSettings from "./slices/CampaignSettingsState";
import OrderNotification from "./slices/OrderNotificationState";
import PromotionState from "./slices/PromotionState";

export const store = configureStore({
  reducer: {
    App: AppStateSlice,
    Product: ProductState,
    Combo: ComboSlice,
    Auth: AuthSlice,
    Order,
    Staff: StaffStateSlice,
    Feedback: FeedbackStateSlice,
    Error: ErrorStateSlice,
    Package: PackageState,
    Settings: CampaignSettings,
    OrderNotification,
    Promotion: PromotionState,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
